module.exports = __webpack_public_path__ + "img/jasskarten.e80232c8.png";